import React from "react";

function CreateTicket() {
  return (
    <div className="container">
      <div className="row p-5 mt-5 mb-5">
        <h1 className="fs-2">To create a ticket, select a relevant topic</h1>
        <div className="col-4 p-5 mt-2 mb-2">
          <h4 className="">
            <i class="fa fa-plus-circle" aria-hidden="true"></i> Account Opening
          </h4>
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            Online Account Opening
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            Offline Account Opening
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            Company, Partnership and HUF Account
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            Opening
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            NRI Account Opening
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            Charges at StockEasy
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            StockEasy IDFC FIRST Bank 3-in-1 Account
          </a>
          <br />
          <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
            Getting Started
          </a>
          <br />
        </div>
        <div className="col-4 p-5 mt-2 mb-2">
  <h4 className="">
    <i class="fa fa-plus-circle" aria-hidden="true"></i> Getting Started
  </h4>
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Create Your Trading Account
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Verify Your Identity (KYC)
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Business & Corporate Accounts Setup
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Account Activation Guide
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Global & NRI Trading Accounts
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Pricing & Brokerage Plans
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Smart 3-in-1 Banking Integration
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Beginner’s Trading Guide
  </a>
  <br />
</div>
       <div className="col-4 p-5 mt-2 mb-2">
  <h4 className="">
    <i class="fa fa-plus-circle" aria-hidden="true"></i> Trading & Investments
  </h4>
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Start Trading Stocks
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Options & Futures Trading
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Mutual Fund Investments
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    IPO Investments
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    AI Trading Signals
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Portfolio Diversification Tips
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Risk Management Tools
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Investment Strategies
  </a>
  <br />
</div>
        <div className="col-4 p-5 mt-2 mb-2">
  <h4 className="">
    <i class="fa fa-plus-circle" aria-hidden="true"></i> Funds & Payments
  </h4>
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Add Funds to Wallet
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Withdraw Trading Balance
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Payment Methods Supported
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Transaction History
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Auto Pay & SIP Setup
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Refund & Settlement Policy
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Bank Account Linking
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Payment Security Guide
  </a>
  <br />
</div>
        <div className="col-4 p-5 mt-2 mb-2">
  <h4 className="">
    <i class="fa fa-plus-circle" aria-hidden="true"></i> AI Tools & Insights
  </h4>
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    AI Market Predictions
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Smart Stock Recommendations
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Automated Trading Bots
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Portfolio Performance Analytics
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Real-Time Market Alerts
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    AI Risk Assessment
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Trend Detection Tools
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Data-Driven Insights
  </a>
  <br />
</div>
        <div className="col-4 p-5 mt-2 mb-2">
  <h4 className="">
    <i class="fa fa-plus-circle" aria-hidden="true"></i> Support & Help
  </h4>
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Help Center
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Raise a Support Ticket
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Live Chat Assistance
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Account Security Help
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Report an Issue
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    FAQs
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    Contact Support Team
  </a>
  <br />
  <a href="" style={{ textDecoration: "none", lineHeight: "2.5" }}>
    User Guides & Tutorials
  </a>
  <br />
</div>
      </div>
    </div>
  );
}

export default CreateTicket;